export default class SaveInfoConsulta {

    save(consulta) {
        localStorage.setItem('data_consulta', JSON.stringify(consulta))
    }

    delete(key) {
        localStorage.removeItem(key)
    }
}
